import React, { Component } from "react";
import Card from "../../components/Card";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";

class RemoPropertySorry extends Component {
  rejectHasTenants = () => {
    let reason = { ...this.props.propertyInformation1 };
    if (reason.rejectHasTenants === true) {
      return true;
    }
    return false;
  };

  rejectSharedOwnership = () => {
    let reason = { ...this.props.propertyInformation1 };
    if (reason.rejectSharedOwnership === true) {
      return true;
    }
    return false;
  };

  rejectMultipleTitles = () => {
    let reason = { ...this.props.propertyInformation1 };
    if (reason.rejectMultipleTitles === true) {
      return true;
    }
    return false;
  };

  rejectManagementCompany = () => {
    let reason = { ...this.props.propertyInformation2 };
    if (reason.clientPaysMaintenanceFees === true && reason.rejectManagementCompany === true) {
      return true;
    }
    return false;
  };

  rejectNegativeEquity = () => {
    let reason = { ...this.props.propertyInformation3 };
    if (reason.rejectNegativeEquity === true) {
      return true;
    }
    return false;
  };

  rejectNotPayingOffAllCharges = () => {
    let reason = { ...this.props.propertyInformation3 };
    if (reason.clientHasMoreThanOneCharge === true && reason.rejectNotPayingOffAllCharges === false) {
      return true;
    }
    return false;
  };

  rejectNegativeEquityAndNotPayingOffAllCharges = () => {
    let reason = { ...this.props.propertyInformation3 };
    if (
      reason.rejectNegativeEquity === true &&
      reason.clientHasMoreThanOneCharge === true &&
      reason.rejectNotPayingOffAllCharges === false
    ) {
      return true;
    }
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="We don’t offer a remortgaging service" removeTopPadding>
          <p>
            We don’t currently work on remortgages. This is something that may change in the future, so please do check
            back with us next time round.
          </p>
        </Card>
        <Image src={imageOfficeWorking} fullWidth />
      </React.Fragment>
    );
  }
}

export default RemoPropertySorry;
